export const shipmentDetail = {
  shipment_detail_form: {
    Action: "",
    PDBShipRef: "",
    VesselName: "",
    LoadPort: "",
    LoadPortAgentEmail: "",
    LoadAgentJobNumber: "",
    LoadingArrival: "",
    LoadingTimelog: "",
    LoadingDeparture: "",
    LoadingPumping: "",
    LoadProduct1: "",
    LoadProduct2: "",
    LoadProduct3: "",
    LoadProduct4: "",
    LoadProduct5: "",
    LoadProduct6: "",
    LoadProduct7: "",
    LoadProduct8: "",
    LoadPumpingProduct1: "",
    LoadPumpingProduct2: "",
    LoadPumpingProduct3: "",
    DischargePort1: "",
    Discharge1ProductFile: "",
    DischargePortAgentEmail1: "",
    DischargeAgentJobNumber1: "",
    Discharge1Arrival: "",
    Discharge1Timelog: "",
    Discharge1Departure: "",
    Discharge1Pumping: "",
    Discharge1Product1: "",
    Discharge1Product2: "",
    Discharge1Product3: "",
    Discharge1DischargeProduct1: "",
    Discharge1DischargeProduct2: "",
    Discharge1DischargeProduct3: "",
    Discharge1PumpingProduct1: "",
    Discharge1PumpingProduct2: "",
    Discharge1PumpingProduct3: "",
    DischargePort2: "",
    Discharge2ProductFile: "",
    DischargePortAgentEmail2: "",
    DischargeAgentJobNumber2: "",
    Discharge2Arrival: "",
    Discharge2Timelog: "",
    Discharge2Departure: "",
    Discharge2Pumping: "",
    Discharge2Product1: "",
    Discharge2Product2: "",
    Discharge2Product3: "",
    Discharge2DischargeProduct1: "",
    Discharge2DischargeProduct2: "",
    Discharge2DischargeProduct3: "",
    Discharge2PumpingProduct1: "",
    Discharge2PumpingProduct2: "",
    Discharge2PumpingProduct3: "",
    DischargePort3: "",
    Discharge3ProductFile: "",
    DischargePortAgentEmail3: "",
    DischargeAgentJobNumber3: "",
    Discharge3Arrival: "",
    Discharge3Timelog: "",
    Discharge3Departure: "",
    Discharge3Pumping: "",
    Discharge3Product1: "",
    Discharge3Product2: "",
    Discharge3Product3: "",
    Discharge3DischargeProduct1: "",
    Discharge3DischargeProduct2: "",
    Discharge3DischargeProduct3: "",
    Discharge3PumpingProduct1: "",
    Discharge3PumpingProduct2: "",
    Discharge3PumpingProduct3: "",
    ReportStatus: "In Progress",
    LoadingArrivalStatus: "In Progress",
    LoadingDepartureStatus: "In Progress",
    LoadingTimelogStatus: "In Progress",
    LoadingDischargeStatus: "In Progress",
    LoadingDischargeProduct1Status: "In Progress",
    LoadingDischargeProduct2Status: "In Progress",
    LoadingDischargeProduct3Status: "In Progress",
    LoadingPumpingStatus: "In Progress",
    LoadingPumpingProduct1Status: "In Progress",
    LoadingPumpingProduct2Status: "In Progress",
    LoadingPumpingProduct3Status: "In Progress",
    Discharge1ArrivalStatus: "In Progress",
    Discharge1TimelogStatus: "In Progress",
    Discharge1DepartureStatus: "In Progress",
    Discharge1DischargeStatus: "In Progress",
    Discharge1DischargeProduct1Status: "In Progress",
    Discharge1DischargeProduct2Status: "In Progress",
    Discharge1DischargeProduct3Status: "In Progress",
    Discharge1PumpingStatus: "In Progress",
    Discharge1PumpingProduct1Status: "In Progress",
    Discharge1PumpingProduct2Status: "In Progress",
    Discharge1PumpingProduct3Status: "In Progress",
    Discharge2ArrivalStatus: "In Progress",
    Discharge2TimelogStatus: "In Progress",
    Discharge2DepartureStatus: "In Progress",
    Discharge2DischargeStatus: "In Progress",
    Discharge2DischargeProduct1Status: "In Progress",
    Discharge2DischargeProduct2Status: "In Progress",
    Discharge2DischargeProduct3Status: "In Progress",
    Discharge2PumpingStatus: "In Progress",
    Discharge2PumpingProduct1Status: "In Progress",
    Discharge2PumpingProduct2Status: "In Progress",
    Discharge2PumpingProduct3Status: "In Progress",
    Discharge3ArrivalStatus: "In Progress",
    Discharge3TimelogStatus: "In Progress",
    Discharge3DepartureStatus: "In Progress",
    Discharge3DischargeStatus: "In Progress",
    Discharge3DischargeProduct1Status: "In Progress",
    Discharge3DischargeProduct2Status: "In Progress",
    Discharge3DischargeProduct3Status: "In Progress",
    Discharge3PumpingStatus: "In Progress",
    Discharge3PumpingProduct1Status: "In Progress",
    Discharge3PumpingProduct2Status: "In Progress",
    Discharge3PumpingProduct3Status: "In Progress",
    SurveyorCompany: "",
    AgentCompany: "",
    DateCreated: "",
    ModifyBy: "",
    DateModify: "",
    DischargePort1AgentCompany: "",
    DischargePort2AgentCompany: "",
    DischargePort3AgentCompany: "",
    DischargePort1SurveyorCompany: "",
    DischargePort2SurveyorCompany: "",
    DischargePort3SurveyorCompany: "",
    Discharge1Product1Vol: "",
    Discharge1Product2Vol: "",
    Discharge1Product3Vol: "",
    Discharge2Product1Vol: "",
    Discharge2Product2Vol: "",
    Discharge2Product3Vol: "",
    Discharge3Product1Vol: "",
    Discharge3Product2Vol: "",
    Discharge3Product3Vol: "",
    ShipmentStatus: "Confirmed",
    Remarks: "",
  },
  shipment_dynamic_form: {
    ShipRef: "",
    VesselName: "",
    OPU: "",
    ModifyBy: "",
    DateCreated: "",
    DateModify: "",
    Unit: "",
    TimelogStatusHdr: "In Progress",
    ShipmentStatus: "Confirmed",
    ports: [
      {
        PortStatus: "Create",
        AgentCompany: "",
        Cargo1: "",
        Cargo1Volume: "",
        Cargo1Unit: "",
        Cargo2: "",
        Cargo2Volume: "",
        Cargo2Unit: "",
        Cargo3: "",
        Cargo3Volume: "",
        Cargo3Unit: "",
        Cargo4: "",
        Cargo4Volume: "",
        Cargo4Unit: "",
        Cargo5: "",
        Cargo5Volume: "",
        Cargo5Unit: "",
        Cargo6: "",
        Cargo6Volume: "",
        Cargo6Unit: "",
        Cargo7: "",
        Cargo7Volume: "",
        Cargo7Unit: "",
        Cargo8: "",
        Cargo8Volume: "",
        Cargo8Unit: "",
        DateCreated: "",
        DateModify: "",
        LaycanEndDate: "",
        LaycanStartDate: "",
        ModifyBy: "",
        OPU: "",
        PortName: "",
        PortType: "",
        SearchIndex: "searchable",
        ShipRef: "",
        SurveyorCompany: "",
        SurveyorEmail: "",
        TimelogFile: "-",
        TimelogStatus: "In Progress",
        VOPS_ID: "",
        VesselName: "",
      },
    ],
  },
  read_data_2: {},
  is_form_loading: false,
  is_data_loading: false,
  is_submit_loading: false,
  is_user_admin: false,
  tabs_index: 0,
  read_data: {},
  default_state: {},
  vessel_list: [],
};



// WEBPACK FOOTER //
// ./src/reducers/shipmentDetail/shipmentDetail.state.js